import { render, staticRenderFns } from "./sendForum.vue?vue&type=template&id=196e492a&"
import script from "./sendForum.vue?vue&type=script&lang=js&"
export * from "./sendForum.vue?vue&type=script&lang=js&"
import style0 from "./sendForum.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports